<template
  ><span>
    <v-badge
      v-if="pending"
      dark
      color="red"
      icon="mdi-sync-alert"
      overlap
      offset-x="20"
      offset-y="20"
    >
      <v-avatar size="40" color="white" @click="goHome" class="elevation-2">
        <img src="@/assets/logo.png" alt="Logo" style="cursor: pointer;" />
      </v-avatar>
    </v-badge>

    <v-avatar
      v-else
      size="40"
      color="white"
      @click="goHome"
      class="elevation-2"
    >
      <img src="@/assets/logo.png" alt="Logo" style="cursor: pointer;" />
    </v-avatar>
  </span>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    // console.log(this.loading);
  },
  methods: {
    goHome() {
      if (this.user.isAnimateur && this.$route.path !== "/animateur") {
        this.$router.push("/animateur");
      } else {
        this.$router.push("/");
      }
    },
  },
  computed: {
    ...mapState({
      pending: (state) => state.Pending.pending,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
